import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getOpportunityMSDocumentListData } from './mockData'
import type { IOpportunityMSDocument } from '~/types/document/models'

export const {
  getDocuments: getOpportunityMSDocuments,
  postDocument: postOpportunityMSDocument,
  patchDocument: patchOpportunityMSDocument,
  deleteDocument: deleteOpportunityMSDocument,
  handlers,
} = makeDocumentAPIs<IOpportunityMSDocument>({
  apiPathEntityNamePrefix: 'opportunityms',
  getDocumentListDataFn: getOpportunityMSDocumentListData,
})
